import { Button } from '@liveauctioneers/hammer-ui-core/button';
import { SealCheck } from '@liveauctioneers/hammer-ui-core/icons';
import { FormattedMessage, useIntl } from '@liveauctioneers/hammer-ui-core/intl';
import { H3 } from '@liveauctioneers/hammer-ui-core/text';
import * as React from 'react';
import styled from 'styled-components';

import { useAppDispatch, useAppSelector } from '@/redux/hooks';
import { getBidderPhoneNumber } from '@/redux/modules/account/user/user.selectors';
import { openPhoneVerificationModal } from '@/redux/modules/modal';

interface ApprovePhoneNumberProps {
    className?: string;
}

export const ApprovePhoneNumber = ({ className }: ApprovePhoneNumberProps) => {
    const dispatch = useAppDispatch();
    const { formatMessage } = useIntl();

    const mobileNumber = useAppSelector(getBidderPhoneNumber);

    const onClick = () => {
        dispatch(openPhoneVerificationModal());
    };

    return (
        <Container className={className}>
            <SealCheck
                color="success"
                size="lg"
                style="duotone"
            />

            <ApprovalHeader>
                <FormattedMessage id="accountSettingsPage.getApprovedFaster" />
            </ApprovalHeader>
            <ApproveButton onClick={onClick}>
                {formatMessage({
                    id: mobileNumber ? 'accountSettingsPage.verifyMobileNumber' : 'accountSettingsPage.addMobileNumber',
                })}
            </ApproveButton>
        </Container>
    );
};

export default ApprovePhoneNumber;

const Container = styled.div`
    padding: 32px;
    border: 1px solid ${({ theme }) => theme.colors.grey400};
    background-color: ${({ theme }) => theme.colors.beige100};
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 384px;

    @media (max-width: ${({ theme }) => theme.breakpoints.tabletWidth}) {
        width: 100%;
    }
`;

const ApprovalHeader = styled(H3)`
    margin-bottom: 32px;
    margin-top: 8px;
    text-align: center;
`;

const ApproveButton = styled(Button)`
    width: 100%;
`;
